// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addtemplate[data-v-29b16258]{width:62.291667rem;margin:0 auto;display:flex}.addtemplate .conter[data-v-29b16258]{width:100%;border:.052083rem solid #ccc;background:#fff;padding:1.041667rem}[data-v-29b16258] .el-input__inner{width:auto}[data-v-29b16258] .btn{margin-right:10.416667rem;text-align:center}.title[data-v-29b16258]{margin:1.041667rem auto;font-size:1.041667rem;text-align:center;color:#409eff}", ""]);
// Exports
module.exports = exports;
